export default "__VITE_ASSET__CLiIhA$x__"